import CartModalController from 'emun.cart/cart-modal.controller.es6'

class PaymentTermsPickerController extends CartModalController {
    constructor($session, $cart, $uibModalInstance, options) {
        'ngInject';
        super($session, $cart, $uibModalInstance, options);
    }
    
    select(paymentTerms) {
        let $ctrl = this;
        $ctrl.picker.selecting.notify(paymentTerms);
        return $ctrl.$cart.applyPaymentTerms({paymentTermsId: paymentTerms.id}).then(res => {
            $ctrl.$close(res);
            $ctrl.picker.selected.notify(res);
        });
    }
    submit(paymentTerms) {
        let $ctrl = this;
        $ctrl.select(paymentTerms);
    }
}

function PaymentTermsPickerFactory($cart, $q, modals, $rootScope) {
    'ngInject';
    class PaymentTermsPicker {
        constructor(options) {
            if(!options) options = {};
            let picker = this;
            ['selecting', 'selected'].forEach(k => {
                picker[k] = $q.defer();
                picker[k].on = picker[k].subscribe = picker[k].sub = cb => picker[k].promise.finally(null, cb);
            });
        }
        open(current) {
            let picker = this;
            if (!current) current = $cart.paymentTerms;
            let modalInstance = picker.modal = modals.open({
                size: 'md',
                templateUrl: 'payment-terms-picker.html',
                controller: PaymentTermsPickerController,
                bindToController: true,
                controllerAs: '$ctrl',
                resolve: {
                    options: () => { return { current, picker, query: picker, title: 'Select payment terms...'} }
                }
            });

            modalInstance.result.then(paymentTerms => {
                picker.selected.notify(paymentTerms);
                $rootScope.$emit('paymentTermsSelected', paymentTerms );
            });
            return modalInstance.result;
        }
    }
    return PaymentTermsPicker;
}
function PaymentTermsPickerDirective($window, $parse, PaymentTermsPicker) {
    // Introduce custom elements for IE8
    $window.document.createElement('payment-terms-picker');
    return {
        scope: false,
        link: function (scope, element, attr) {
            let picker = new PaymentTermsPicker();
            let fieldName = attr.ngModel || attr.paymentTermsPicker || 'paymentTermsPicker';

            attr.onSelected && picker.selected.on(cart => $parse(attr.onSelected)(scope, {$selected:cart}));
            fieldName && $parse(fieldName).assign(scope, picker);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            $targets.on('click', e => picker.open(scope.$eval(attr.current)));
        }
    };
}

angular.module('emun.cart')
    .directive('paymentTermsPicker', PaymentTermsPickerDirective)
    .factory('PaymentTermsPicker', PaymentTermsPickerFactory);